/**
 * StepVisitedConditionType - Condition qui vérifie si une étape a été visitée
 * Identique à Flutter ComesFromConditionType
 */

import {ConditionType} from '../types/ConditionType';
import {GameState} from '../../../models/GameState';
import {PlayerCondition} from '../../../models/PlayerCondition';

export class StepVisitedConditionType implements ConditionType {
  typeName = 'COND_STEP_VISITED';
  messageKey = 'laventurier.condition.step_visited.name';
  descriptionKey = 'laventurier.condition.step_visited.desc';
  errorKey = 'laventurier.condition.step_visited.error';
  hasValue = true;
  hasAttribute = false;

  evaluate(gameState: GameState, condition: any): boolean {
    const stepNumber = Number(condition.value || condition.stepNumber);
    if (!stepNumber || isNaN(stepNumber)) {
      console.log('[StepVisitedConditionType] FALSE: invalid step number');
      return false;
    }

    // Vérifier dans recordedPaths (format: "1-2-3-4")
    const recordedPaths = gameState.data.recordedPaths || '';
    const stepStr = stepNumber.toString();
    const pathParts = recordedPaths.split('-').filter((p) => p);

    const result = pathParts.includes(stepStr);
    console.log(`[StepVisitedConditionType] ${result ? 'TRUE' : 'FALSE'}: step ${stepNumber} in recordedPaths: [${pathParts.join(',')}]`);
    return result;
  }
}
